let module = angular.module('app.resources');

module.factory('StaticRTMP', function StaticRTMP($resource) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/static_rtmps/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT',
      },
      create: {
        method: 'POST',
      },
      delete: {
        method: 'DELETE',
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/static-rtmp.js